import { PaginatedDataDTO } from "@bottega52/commons-pagination";
import { Button, Card } from "@material-ui/core";
import { WithStyles, createStyles, withStyles } from '@material-ui/core/styles';
import DomainsIcon from '@material-ui/icons/Domain';
import WarningIcon from '@material-ui/icons/Warning';
import * as React from "react";
import { ConnectedProps, connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import * as ModalsActions from '../../redux/modals/modals.actions';
import * as SettingsActions from '../../redux/settings/settings.actions';
import { IState } from '../../redux/store';
import { IDemoPlantInDTO } from "../../repository/jago/model/input/IDemoPlantInDTO";
import AbilityProvider from "../../services/PermissionService/AbilityProvider";
import { PERMISSIONS } from "../../services/PermissionService/PermissionConstants";
import { ModalTypes } from "../Modals/ModalTypes";
import ReduxLanguage from "../ReduxLanguage";
import UserDemoPlantsTable from "./UserDemoPlantsTable";

const styles = createStyles({
  container: {
    display: 'flex',
    marginTop: 20,
    flexDirection: 'column',
  },
  cardContainer: {
    padding: 10,
    borderLeft: '3px solid #5AC0B1',
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  headerInner: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  headerTextContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  icon: {
    marginRight: 5,
    width: 25,
  },
  title: {
    fontWeight: 'bold'
  },
  tableContainer: {
    display: 'flex',
    backgroundColor: 'white',
    height: 'calc(100vh - 380px)',
    width: '100%',
    marginTop: 10
  }
});

export interface IUserDemoPlantsState {
  pageSize: number;
}

type IReduxProps = ConnectedProps<typeof connector> & RouteComponentProps<any>;

export interface IUserDemoPlantsProps extends WithStyles<typeof styles> {
  language: string;
}

export type ComponentProps = IUserDemoPlantsProps & IReduxProps;

class UserDemoPlantsSection extends React.Component<ComponentProps, IUserDemoPlantsState> {

  constructor(props: ComponentProps) {
    super(props);
    this.state = {
      pageSize: 100
    };
  }

  async onOpenDemoPlant(demoPlant: IDemoPlantInDTO) {
    // TODO: Implement open demo plant logic
    window.open(demoPlant.url, '_blank');
  }

  async onFetchDemoPlantsOnPage(page: number) {
    const { dispatch } = this.props;
    const { pageSize } = this.state;
    // TODO: Add the corresponding action to fetch demo plants
    // await dispatch<any>(DemoActions.fetchDemoPlants({ page, pageSize }));
  }

  async onPageSizeChange(pageSize: number) {
    const { dispatch } = this.props;
    this.setState({ pageSize }, async () => {
      // TODO: Add the corresponding action to fetch demo plants
      // await dispatch<any>(DemoActions.fetchDemoPlants({ page: 0, pageSize }));
    });
  }

  public render() {
    const { demoPlants, classes } = this.props;
    const { pageSize } = this.state;
    
    const canCreateDemoPlant = AbilityProvider.getAbilityHelper().hasPermission(PERMISSIONS.DOMAIN_DEMO_CREATE);

    return (
      <div className={classes.container}>
        <Card className={classes.cardContainer}>
          <div className={classes.header}>
            <div className={classes.headerInner}>
              <DomainsIcon className={classes.icon} />
              <h3 className={classes.title}><ReduxLanguage languageKey="demoSystem.title"/></h3>
            </div>
            {canCreateDemoPlant && 
              <Button
                variant="contained"
                style={{ fontWeight: 'bold', backgroundColor: '#5AC0B1', fontSize: 11, color: 'white' }}
                onClick={() => {/* TODO: Implement create new demo plant */}}
              >
                <ReduxLanguage languageKey="forms.createNew" />
              </Button>
            }
          </div>
          <div className={classes.tableContainer}>
            <UserDemoPlantsTable
              rowsPerPage={pageSize}
              demoPlants={demoPlants as PaginatedDataDTO<IDemoPlantInDTO>}
              onPageSizeChange={pageSize => this.onPageSizeChange(pageSize)}
              onFetchElementsOnPage={page => this.onFetchDemoPlantsOnPage(page)}
              onOpenDomain={demoPlant => this.onOpenDemoPlant(demoPlant)}
            />
          </div>
        </Card>
      </div>
    );
  }
}

function mapStateToProps(state: IState) {
  return {
    language: state.settings.language,
    demoPlants: state.credits.demoPlants?.data, // TODO: Add the corresponding state
  };
}

const connector = connect(mapStateToProps);

export default connector(withRouter(withStyles(styles)(UserDemoPlantsSection))); 